import Css from './Customer.module.css';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Col, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { AddCommar } from 'components/MyControl';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export default function TopCustomerByRevenue({ data_top = [] }) {
    const [labels, setLabels] = useState([]);
    const [datas, setDatas] = useState([]);

    //const labels = ['สยามมิชลิน จำกัด', 'อินเตอร์โกลด์ โกลด์เทรด จำกัด', 'ไดกิ้น อินดัสทรีส์ (ประเทศไทย) จำกัด', 'สยามคูโบต้าคอร์ปอเรชั่น จำกัด', 'เรียล มูฟ จำกัด'];

    const data = {
        labels: labels,
        datasets: [
            {
                label: '',
                data: datas,
                backgroundColor: [
                    '#A19FFB',
                ],
                borderColor: [
                    '#A19FFB',
                ],
                borderWidth: 1,
            },
        ],
    };
    const options = {
        indexAxis: 'y',
        elements: {
            bar: {
                borderWidth: 2,
            },
        },
        responsive: true,
        plugins: {
            legend: {
                display: false,
            }
        },
    }

    useEffect(() => {
        if (data_top.length > 0) {
            let company_names = [];
            let paid_amounts = [];

            data_top.map(obj => {
                company_names.push(obj.company_name);
                paid_amounts.push((obj.paid_amount));

                return 0;
            });

            setLabels(company_names);
            setDatas(paid_amounts);
        }
        //console.log(datas);
    }, [data_top])

    return (
        <div className={Css.Graph_Box + ' shadow'}>
            <div className={Css.Content}>
                <div className={Css.Header}>
                    <h6>Top 5 Customers By Revenue</h6>
                </div>
                <div className={Css.Content}>
                    <div >
                        {
                            <Bar data={data} options={options} ></Bar>
                        }

                    </div>
                </div>
            </div>
            <div className={Css.Footer + ' d-none'}>
                <a href={'#'}>View Full Plan</a>
            </div>
        </div>
    )
}